var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('tracker-create-modal'),_c('div',[_c('app-search-bar',{on:{"submit":_vm.filter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }